import React, { useEffect } from "react";
import dayjs from "dayjs";
import { Form, Flex, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { HeaderApp } from "../../shared";
import Loading from "../../shared/components/Loading";
import openNotification from "../../../utils/openNotification";
import { useFetchCompany } from "../hooks/useFetchCompany";
import { useEditCompany } from "../hooks/useEditCompany";
import CompanyForm from "../components/CompanyForm";
import type { Company } from "../types";

const EditCompany: React.FC = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const navigate = useNavigate();

  const { data: company, isLoading } = useFetchCompany();
  const { mutate: editMutation, isPending } = useEditCompany();

  useEffect(() => {
    if (!company) return;
    form.setFieldsValue({
      rfc_company: company.rfc_company,
      name_company: company.name_company,
      capital_regime: company.capital_regime,
      public_name_company: company.public_name_company,
      date_start_operations: company.date_start_operations
        ? dayjs(company.date_start_operations)
        : null,
      status_sat: company.status_sat,
      regimes: (company.regimes ?? []).map((r) => ({
        ...r,
        start_date: r.start_date ? dayjs(r.start_date) : null,
        end_date: r.end_date ? dayjs(r.end_date) : null,
      })),
      obligations: (company.obligations ?? []).map((o) => ({
        ...o,
        start_date: o.start_date ? dayjs(o.start_date) : null,
        end_date: o.end_date ? dayjs(o.end_date) : null,
      })),
      company_economic_act: (company.company_economic_act ?? []).map((a) => ({
        ...a,
        end_date: a.end_date ? dayjs(a.end_date) : null,
      })),
    });
  }, [company, form]);

  const handleFinish = (values: Company) => {
    editMutation(values, {
      onSuccess: () => {
        openNotification("success", "Éxito", "Empresa actualizada correctamente");
        navigate("/empresa/detalles");
      },
      onError: (error) => {
        openNotification("error", "Error", error.message);
      },
    });
  };

  if (isLoading) return <Loading />;

  return (
    <Flex vertical style={{ background: token.colorBgLayout }}>
      <HeaderApp sectionName="Editar Empresa" showBack backPath="/empresa/detalles" />

      <Flex
        vertical
        gap={28}
        style={{
          maxWidth: 680,
          width: "100%",
          margin: "0 auto",
          padding: "28px 24px 100px",
        }}
      >
        <CompanyForm
          form={form}
          onFinish={handleFinish}
          isPending={isPending}
          buttonText="Guardar Cambios"
          formId="edit-company-form"
          rfcReadOnly
        />
      </Flex>
    </Flex>
  );
};

export default EditCompany;
